import React from 'react';
import { Star, MessageSquareQuote } from 'lucide-react';

const reviews = [
  {
    name: 'Sarah Jenkins',
    role: 'Content Creator',
    avatar: 'SJ',
    text: 'Typing "make cinematic golden hour lighting" on my raw smartphone video transformed it completely. PFP AI saves me hours of keyframing!',
    rating: 5,
    tag: 'Smart Edits',
  },
  {
    name: 'David K.',
    role: 'Digital Artist',
    avatar: 'DK',
    text: 'The text-to-image generator produces incredible fidelity. Plus, the virtual hairstyle try-on works flawlessly on regular portraits.',
    rating: 5,
    tag: 'Photo Generation',
  },
  {
    name: 'Elena Rostova',
    role: 'Social Media Manager',
    avatar: 'ER',
    text: 'Upscaling old product images up to 4× simply by typing enhancement commands feels like pure magic. Absolute game changer.',
    rating: 5,
    tag: 'Instant Enhance',
  },
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-20 px-6 max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-[#161B26] border border-gray-800 px-4 py-1.5 rounded-full text-sm font-semibold text-[#F6D365] mb-4">
          <MessageSquareQuote className="w-4 h-4" /> Loved by Creators Worldwide
        </div>
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
          What Users Say About <span className="text-[#E63946]">Simple English Editing</span>
        </h2>
        <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-base md:text-lg">
          Thousands are ditching complex editing timelines for lightning-fast AI English instructions.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {reviews.map((rev, i) => (
          <div
            key={i}
            className="bg-[#121622] border border-gray-800 rounded-3xl p-8 hover:border-[#E63946]/40 transition-all duration-300 flex flex-col justify-between group hover:-translate-y-1"
          >
            <div>
              <div className="flex items-center justify-between mb-6">
                <span className="text-xs font-bold uppercase tracking-wider bg-[#1B2030] text-[#E63946] px-3 py-1 rounded-full border border-gray-800/80">
                  {rev.tag}
                </span>
                <div className="flex gap-1">
                  {[...Array(rev.rating)].map((_, idx) => (
                    <Star key={idx} className="w-4 h-4 fill-[#F6D365] text-[#F6D365]" />
                  ))}
                </div>
              </div>
              <p className="text-gray-300 text-base leading-relaxed italic mb-6">
                "{rev.text}"
              </p>
            </div>

            <div className="flex items-center gap-4 pt-4 border-t border-gray-800/60">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#E63946] to-[#F6D365] flex items-center justify-center font-bold text-white shadow-md text-lg shrink-0">
                {rev.avatar}
              </div>
              <div>
                <h4 className="font-bold text-white group-hover:text-[#E63946] transition-colors">
                  {rev.name}
                </h4>
                <p className="text-xs text-gray-400">{rev.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
